import React, { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Chip,
    Grid,
    ThemeProvider,
    createTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SharedNavBar, { NavItem } from '.././components/SharedNavBar';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PublicIcon from '@mui/icons-material/Public';
import SavingsIcon from '@mui/icons-material/Savings';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import MutualFundsSection from './MutualFundsSection';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#121212',
            paper: '#1e1e1e',
        },
    },
});

const navItems: NavItem[] = [
    { label: 'Dashboard', icon: <DashboardIcon />, href: '/' },
    { label: 'Investments', icon: <AccountBalanceIcon />, href: '/investments' },
    { label: 'Global', icon: <PublicIcon />, href: '/global' },
    { label: 'Savings', icon: <SavingsIcon />, href: '/fixed-income' },
    { label: 'Compliance', icon: <VerifiedUserIcon />, href: '/kyc' },
];

const InvestmentsDashboard = () => {
    const [tabValue, setTabValue] = useState(0);
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <ThemeProvider theme={darkTheme}>

            <Box sx={{ minHeight: '100vh', py: 4 }}>
                <Container maxWidth="md">
                    {/* Unified Portfolio Snapshot */}
                    <Card sx={{ mb: 3, borderRadius: 3 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Unified Portfolio
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <Chip label="Mutual Funds: ₦2,450,000" color="primary" />
                                </Grid>
                                <Grid item>
                                    <Chip label="NGX Stocks: ₦1,200,000" />
                                </Grid>
                                <Grid item>
                                    <Chip label="US Stocks: $3,400" />
                                </Grid>
                                <Grid item>
                                    <Chip label="Cash: ₦350,000" />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    {/* Asset Modules */}
                    <Accordion defaultExpanded sx={{ borderRadius: 3, mb: 2 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">Mutual Funds</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MutualFundsSection />
                        </AccordionDetails>
                    </Accordion>

                    <Accordion sx={{ borderRadius: 3, mb: 2 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">NGX Direct Trading</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography color="text.secondary">
                                Full brokerage module (order book, CSCS, dividends).
                            </Typography>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion sx={{ borderRadius: 3 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">Global Markets</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography color="text.secondary">
                                US stocks & ETFs via foreign broker partner.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </Container>
            </Box>
        </ThemeProvider>
    );
};

export default InvestmentsDashboard;
